<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-xs-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_reference"
            filterable
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_reference"
              :label="item.name"
              :value="item.shop_reference"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
          >ค้นหา</el-button>
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <v-data-table :headers="headers" :items="items" :pagination.sync="pagination">
        <template v-slot:items="props">
          <td>{{ props.item.ref_no }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.quantity | numFormat('0,0')}}</td>
          <td class="text-xs-right">
            <strong>฿ {{props.item.food_amount | numFormat('0,0')}}</strong>
          </td>
          <td class="text-xs-right">
            <strong>฿ {{props.item.delivery_amount | numFormat('0,0')}}</strong>
          </td>
          <td class="text-xs-right">
            <strong>฿ {{props.item.discount_amount | numFormat('0,0')}}</strong>
          </td>
        </template>
        <template v-slot:footer v-if="total!=null">
          <tr class>
            <td :colspan="headers"></td>
            <td class="font-weight-bold blue--text">รวมทั้งหมด</td>
            <td
              class="text-xs-left font-weight-bold blue--text"
            >{{total.quantity | numFormat('0,0')}}</td>
            <td
              class="text-xs-right font-weight-bold blue--text"
            >{{total.food_amount | numFormat('0,0')}}</td>
            <td
              class="text-xs-right font-weight-bold blue--text"
            >{{total.delivery_amount | numFormat('0,0')}}</td>
            <td
              class="text-xs-right font-weight-bold blue--text"
            >{{total.discount_amount | numFormat('0,0')}}</td>
          </tr>
        </template>
      </v-data-table>
    </el-card>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      form: {
        shop_reference: "",
      },
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "ref_no",
        },
        { text: "ชื่อร้านค้า", value: "name" },
        { text: "จำนวนบิล", value: "quantity" },
        { text: "ค่าอาหาร", align: "right", value: "food_amont" },
        { text: "ค่าจัดส่ง", align: "right", value: "delivery_amount" },
        { text: "ส่วนลด", align: "right", value: "discount_amount" },
      ],

      pagination: { sortBy: "quantity", descending: true, rowsPerPage: -1 },
      shopList: [],
      items: [],
      total: null,
    };
  },
  created() {
    Service.Shop.gets().then((res) => {
      if (res.success) {
        this.shopList = res.data.map((item) => {
          return {
            shop_reference: item.ref_no,
            name: item.name,
            status: item.status,
          };
        });

        this.shopList = this.shopList.filter(function (item) {
          return ["published", "temp_close"].includes(item.status);
        });

        this.shopList.unshift({
          shop_reference: "",
          name: "ทั้งหมด",
          status: "published",
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        shop_reference: this.form.shop_reference,
      };

      Service.Report.shop(data).then((res) => {
        this.items = res.data.map((item) => {
          return {
            ref_no: item.shop.ref_no,
            name: item.shop.shop_name,
            quantity: item.quantity,
            food_amount: item.food_amount,
            delivery_amount: item.delivery_amount,
            discount_amount: item.discount_amount,
          };
        });

        this.total = {
          quantity: this.items.reduce(
            (acc, item) => acc + parseInt(item.quantity),
            0
          ),
          food_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.food_amount),
            0
          ),
          delivery_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.delivery_amount),
            0
          ),
          discount_amount: this.items.reduce(
            (acc, item) => acc + parseInt(item.discount_amount),
            0
          ),
        };
      });
    },
  },
};
</script>